import { ValidatorFn, Validators } from "@angular/forms";
import { Subject } from "rxjs";

export class InputBase<T> {
	private _value?: T | null;
	key: string;
	type: string;
	inputFieldType?: string;
	required?: boolean;
	maxLength?: number;
	translateKey?: string;
	errorKey?: string;
	untranslatableName?: string;
	helpMessage?: string | null;
	infoMsgKey?: string;
	/* Checkbox only, implement for other types if needed */
	warnMsgKey?: string;
	readonly?: boolean;
	disabled?: boolean;
	hidden: boolean;
	/* Text field only */
	expand?: () => void;
	focus: boolean;
	placeholderKey?: string | null;
	validators: ValidatorFn[] = new Array<ValidatorFn>();
	readonly valueSubject = new Subject<unknown>();
	isCascading?: boolean;

	constructor(args: {
		key: string;
		value?: T | null;
		type: string;
		inputFieldType?: string;
		required?: boolean;
		maxLength?: number | null;
		translateKey?: string | null;
		untranslatableName?: string | null;
		readonly?: boolean | null;
		disabled?: boolean | null;
		hidden?: boolean;
		focus?: boolean;
		placeholderKey?: string | null;
		errorKey?: string | null;
		isCascading?: boolean;
	}) {
		this.key = args.key;
		this._value = args.value;
		this.type = args.type;
		this.inputFieldType = args.inputFieldType;
		this.required = args.required;
		this.maxLength = args.maxLength || undefined;
		this.translateKey = args.translateKey || undefined;
		this.errorKey = args.errorKey || args.translateKey || undefined;
		this.untranslatableName = args.untranslatableName || undefined;
		this.readonly = args.readonly || false;
		this.disabled = args.disabled || false;
		this.hidden = args.hidden || false;
		this.focus = args.focus || false;
		this.placeholderKey = args.placeholderKey;
		this.isCascading = args.isCascading;

		this.addDefaultValidators();
	}

	addValidator(validator: ValidatorFn): void {
		this.validators.push(validator);
	}

	private addDefaultValidators(): void {
		if (this.required) {
			this.validators.push(Validators.required);
		}
		if (this.maxLength) {
			this.validators.push(Validators.maxLength(this.maxLength));
		}
	}

	setValue(newValue: T): void {
		this._value = newValue;
		this.valueSubject.next(newValue);
	}

	get value(): T | null | undefined {
		return this._value;
	}

	set value(value: T | null | undefined) {
		this._value = value;
	}
}

export class CommonArgs<T> {
	key!: string;
	value?: T | null;
	required?: boolean;
	translateKey?: string | null;
	untranslatableName?: string | null;
	readonly?: boolean | null;
	hidden?: boolean;
	infoMsgKey?: string;
	isCascading?: boolean;
}
